export type GetCheckoutMessageLogApiResponse = CheckoutMessageLogResponseBody;
export type GetCheckoutMessageLogApiArg = {
  checkoutId: string;
};

export type CheckoutMessageLogEntryResponseBody = {
  id: string;
  /** Whether DMS produced or received the message. */
  direction: 'outbound' | 'inbound';
  /** Outbound: the logical channel (dms.sale). Inbound: the Kafka topic name as consumed, environment prefix included. */
  channel: string;
  /** produced = encoded for production (before the broker flush); received = decoded onto the bus; ignored = arrived but the serializer degraded it to a no-op (unmapped eventType or a schema-validation skip); failed = production or handling threw — inbound, the envelope went on to the ACC failure sink. */
  status: 'produced' | 'received' | 'ignored' | 'failed';
  eventType: string | null;
  messageClass: string | null;
  checkoutId: string | null;
  executionId: string | null;
  documentId: string | null;
  transactionId: string | null;
  /** The full wire body, verbatim. */
  payload: Record<string, unknown> | null;
  kafkaKey: string | null;
  kafkaPartition: number | null;
  kafkaOffset: number | null;
  kafkaTimestampMs: number | null;
  errorClass: string | null;
  errorMessage: string | null;
  recordedAt: string;
};

export type CheckoutMessageLogResponseBody = {
  checkoutId: string;
  /** All captured messages correlated to the checkout, oldest first. */
  messages: CheckoutMessageLogEntryResponseBody[];
};
